<template>
  <div class="sso-view-switcher">
    <div
      ref="tabWrapper"
      class="sso-view-switcher-tabs ml-4"
    >
      <div
        class="sso-view-switcher-slider"
        :style="sliderStyle"
      />
      <button
        type="button"
        :class="['sso-view-switcher-tab', { active: activeView === 'saml' }]"
        @click="setActive('saml')"
      >
        SAML
      </button>
      <button
        type="button"
        :class="['sso-view-switcher-tab', { active: activeView === 'sso' }]"
        @click="setActive('sso')"
      >
        Organization login
      </button>
    </div>
    <div class="sso-view-switcher-content">
      <div v-show="activeView === 'saml'">
        <slot name="saml" />
      </div>
      <div v-show="activeView === 'sso'">
        <slot name="sso" />
      </div>
    </div>
  </div>
</template>

<script>
import {
  ref, computed, watch, nextTick, onMounted,
} from 'vue';

export default {
  name: 'SsoViewSwitcher',

  setup() {
    const activeView = ref('sso');
    const tabWrapper = ref(null);
    const sliderLeft = ref('0px');
    const sliderWidth = ref('0px');

    const sliderStyle = computed(() => ({
      left: sliderLeft.value,
      width: sliderWidth.value,
    }));

    const updateSlider = () => {
      const el = tabWrapper.value?.querySelector('.sso-view-switcher-tab.active');
      if (el) {
        const rect = el.getBoundingClientRect();
        const parentRect = el.parentElement.getBoundingClientRect();
        sliderLeft.value = `${rect.left - parentRect.left}px`;
        sliderWidth.value = `${rect.width}px`;
      }
    };

    const setActive = (view) => {
      activeView.value = view;
      nextTick(updateSlider);
    };

    watch(activeView, () => { nextTick(updateSlider); }, { immediate: true });
    onMounted(() => { nextTick(updateSlider); });

    return {
      activeView,
      tabWrapper,
      sliderStyle,
      setActive,
    };
  },
};
</script>

<style lang="less" scoped>
.sso-view-switcher-tabs {
  position: relative;
  width: fit-content;
  min-width: 280px;
  margin-top: 12px;
  padding: 6px;
  display: flex;
  align-items: center;
  gap: 0;
  overflow: hidden;
  background-color: @white;
  border-radius: 48px;
  border: 1px solid @stroke-default;
}

.sso-view-switcher-slider {
  position: absolute;
  top: 6px;
  bottom: 6px;
  border-radius: 32px;
  background-color: @bg-canvas;
  transition: all 0.3s ease;
  z-index: 0;
}

.sso-view-switcher-tab {
  position: relative;
  flex: 1 1 0;
  padding: 8px;
  border-radius: 32px;
  border: none;
  background: transparent;
  cursor: pointer;
  color: @text-light;
  white-space: nowrap;
  font-weight: 500;
  font-size: 13px;
  transition: color 0.3s ease;

  &.active {
    color: @text-brand;
  }
}

.sso-view-switcher-content {
  padding-top: 0;
}
</style>
